import { ActionType, DeclainedReasonId, Inquiry, SchedulerAction } from './SchedulerInquiry.types';

export const initialState: Inquiry = {
  consentToGeneticCounselingAt: undefined,
  consentToShareResultsAt: undefined,
  declineReason: undefined,
  geneticCounselingConsent: undefined,
  patientContacted: undefined,
  resultsSharingConsent: undefined,
};

export const schedulerInquiryReducer = (inquiry: Inquiry, action: SchedulerAction): Inquiry => {
  switch (action.type) {
    case ActionType.CONTACT: {
      const patientContacted = action.payload?.value;
      if (patientContacted) {
        return {
          ...inquiry,
          patientContacted,
        };
      } else {
        return {
          declineReason: undefined,
          geneticCounselingConsent: undefined,
          patientContacted,
          resultsSharingConsent: undefined,
        };
      }
    }
    case ActionType.DECLINE:
      return {
        ...inquiry,
        declineReason: action.payload?.declineReason as DeclainedReasonId,
      };
    case ActionType.GENETIC_COUNSELING_CONSENT: {
      const geneticCounselingConsent = action.payload?.value;
      if (geneticCounselingConsent) {
        return {
          ...inquiry,
          declineReason: undefined,
          declineReasonDescription: undefined,
          geneticCounselingConsent,
          consentToGeneticCounselingAt: action.payload?.timestamp,
        };
      } else {
        return {
          ...inquiry,
          geneticCounselingConsent,
          resultsSharingConsent: undefined,
        };
      }
    }
    case ActionType.RESULTS_SHARING_CONSENT:
      return {
        ...inquiry,
        resultsSharingConsent: action.payload?.value,
        consentToShareResultsAt: action.payload?.timestamp,
      };
    case ActionType.RESET:
      return initialState;
  }
};
